import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from 'react';

import api from './api';
import AnnounSection from './components/announ_section';
import ProtectedRoutes from './components/protected-route';
import SingleNewsCard from './components/single-news-card';
import ConferenceUsers from './pages/conferences';
import SignIn from './pages/signin';
import Main from './pages/main';
import News from './pages/news';
import FlatPages from './pages/flatpages';
import Schools from './pages/schools';
import UserList from './pages/conferences/user-list';
import RegistrationLite from './pages/conferences/registration_lite';
import ConferencesList from './pages/conferences/list';
import Bulletins from './pages/bulletins';
import Documents from './pages/documents';
import NotFound from './pages/404';

import { AuthContext } from './contexts'



function App() {
    const [loggedIn, setLoggedIn] = useState(null)
    const [user, setUser] = useState({})

    const authorization = ({
        username, password
    }) => {
        api.signin({
            username, password
        }).then(res => {
            if (res.auth_token) {
                localStorage.setItem('auth_token', res.auth_token)
                api.getUserData()
                    .then(res => {
                        setUser(res)
                        setLoggedIn(true)
                    })
                    .catch(err => {
                        setLoggedIn(false)
                    })
            } else {
                setLoggedIn(false)
            }
        })
            .catch(err => {
                const errors = Object.values(err)
                if (errors) {
                    alert(errors.join(', '))
                }
                setLoggedIn(false)
            })
    }

    useEffect(_ => {
        async function getUsers() {
            const token = localStorage.getItem('auth_token')
            if (token) {
                return api.getUserData()
                    .then(res => {
                        setUser(res)
                        setLoggedIn(true)
                    })
                    .catch(err => {
                        setLoggedIn(false)
                    })
            }
            setLoggedIn(false)
        }
        getUsers();

    }, [])
    return (
        <div className="App">
            <AuthContext.Provider value={loggedIn}>
                <div className="container">
                    <Router>
                        <div className="announ">
                            <AnnounSection />
                        </div>
                        <div className="content_area">
                            <Routes>
                                <Route exact path='/signin' element={<SignIn
                                    onSignIn={authorization}
                                />} />
                                <Route exact path="/" element={<Main />}></Route>
                                <Route
                                    path="/news/:id"
                                    element={<SingleNewsCard />}
                                >
                                </Route>
                                <Route exact path="/news" element={<News />}></Route>
                                <Route exact path="/management/" element={<FlatPages />}></Route>
                                <Route exact path="/about/" element={<FlatPages />}></Route>
                                <Route exact path="/schools/" element={<Schools />}></Route>
                                <Route exact path="/conferences/" element={<ConferencesList />}></Route>
                                <Route exact path="/bulletins/" element={<Bulletins />}></Route>
                                <Route exact path="/documents/" element={<Documents />}></Route>

                                <Route path="*" element={<NotFound />} />

                                <Route exact path="/userList/" element={<UserList />}></Route>
                                <Route exact path="/userList/registrationLite" element={<RegistrationLite />}></Route>

                                {/* <Route exact path='/' element={<ProtectedRoutes />}>
                                    <Route exact path="/userList/" element={<UserList />}></Route>
                                    <Route exact path="/userList/registrationLite" element={<RegistrationLite />}></Route>
                                </Route> */}
                                <Route exact path="/registrationUsers/" element={<ConferenceUsers />}></Route>
                            </Routes>
                        </div>
                    </Router>
                </div>
            </AuthContext.Provider>
        </div>
    );
}

export default App;
